import { render, staticRenderFns } from "./LocalidadeRemocao.vue?vue&type=template&id=2e8efdcd"
import script from "./LocalidadeRemocao.vue?vue&type=script&lang=js"
export * from "./LocalidadeRemocao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports